import { render } from "./CompanyHistory.vue?vue&type=template&id=2d3b4aab"
import script from "./CompanyHistory.vue?vue&type=script&lang=js"
export * from "./CompanyHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__